module.exports = __webpack_public_path__ + "static/media/lc.e094620d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/lc.svg
// module id = 173
// module chunks = 0